// ── Service de Convites/Acesso (núcleo/aplicação) ─────────────────
// Validações do fluxo de convite/onboarding. Recebe o repositório via porta.

import type {
  IInviteRepository,
  InviteLookup,
  PendingInvite,
  PendingProfile,
  AccessRpcResult,
  CreateInviteParams,
} from '../ports/IInviteRepository';

export class InviteService {
  constructor(private readonly repo: IInviteRepository) {}

  lookupInvite = (token: string): Promise<InviteLookup> => {
    if (!token) throw new Error('token e obrigatorio.');
    return this.repo.lookupInvite(token);
  };

  claimInvite = (token: string): Promise<AccessRpcResult> => {
    if (!token) throw new Error('token e obrigatorio.');
    return this.repo.claimInvite(token);
  };

  acceptInvite = (token: string, nome: string, avatarUrl?: string): Promise<InviteLookup> => {
    if (!token) throw new Error('token e obrigatorio.');
    if (!nome?.trim()) throw new Error('nome e obrigatorio.');
    return this.repo.acceptInvite(token, nome.trim(), avatarUrl);
  };

  listPendingInvites = (workspaceId: string): Promise<PendingInvite[]> => {
    if (!workspaceId) return Promise.resolve([]);
    return this.repo.listPendingInvites(workspaceId);
  };

  listPendingProfiles = (): Promise<PendingProfile[]> => this.repo.listPendingProfiles();

  createInvite = (params: CreateInviteParams): Promise<AccessRpcResult> => {
    if (!params?.workspaceId) throw new Error('workspaceId e obrigatorio.');
    return this.repo.createInvite(params);
  };

  createReusableAexInvite = (workspaceId: string): Promise<AccessRpcResult> => {
    if (!workspaceId) throw new Error('workspaceId e obrigatorio.');
    return this.repo.createReusableAexInvite(workspaceId);
  };

  cancelInvite = (inviteId: string): Promise<AccessRpcResult> => {
    if (!inviteId) throw new Error('inviteId e obrigatorio.');
    return this.repo.cancelInvite(inviteId);
  };

  approveUser = (userId: string): Promise<AccessRpcResult> => {
    if (!userId) throw new Error('userId e obrigatorio.');
    return this.repo.approveUser(userId);
  };

  rejectUser = (userId: string): Promise<AccessRpcResult> => {
    if (!userId) throw new Error('userId e obrigatorio.');
    return this.repo.rejectUser(userId);
  };
}
